/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { ViewStateProto } from './view-state-proto';

export class ViewProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ViewProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsViewProto(bb: flatbuffers.ByteBuffer, obj?: ViewProto): ViewProto {
    return (obj || new ViewProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsViewProto(bb: flatbuffers.ByteBuffer, obj?: ViewProto): ViewProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ViewProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  uniqueId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  state(obj?: ViewStateProto): ViewStateProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new ViewStateProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  canvas(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  children(obj?: ViewProto): ViewProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new ViewProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  previous(obj?: ViewProto): ViewProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? (obj || new ViewProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  uniqueId64(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0');
  }

  static startViewProto(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addUniqueId(builder: flatbuffers.Builder, uniqueId: number) {
    builder.addFieldInt32(0, uniqueId, 0);
  }

  static addState(builder: flatbuffers.Builder, stateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, stateOffset, 0);
  }

  static addCanvas(builder: flatbuffers.Builder, canvas: number) {
    builder.addFieldInt32(2, canvas, 0);
  }

  static addChildren(builder: flatbuffers.Builder, childrenOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, childrenOffset, 0);
  }

  static addPrevious(builder: flatbuffers.Builder, previousOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, previousOffset, 0);
  }

  static addUniqueId64(builder: flatbuffers.Builder, uniqueId64: bigint) {
    builder.addFieldInt64(6, uniqueId64, BigInt('0'));
  }

  static endViewProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }
}
